module.exports = __webpack_public_path__ + "img/qilin-stage1-sulking.020ffae8.png";